import { Component, OnInit, ViewEncapsulation, Input, ElementRef, ViewChild } from '@angular/core';
import {NgbModal, ModalDismissReasons, NgbModalOptions} from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'lp2-mobile-translator-tool',
  templateUrl: './mobile-translator-tool.component.html',
  styleUrls: ['./mobile-translator-tool.component.scss']
})
export class MobileTranslatorToolComponent {
  @ViewChild('content') content: ElementRef;

  constructor(private modalService: NgbModal) { }

  public open() {
    const modalOptions: NgbModalOptions = {
      size: 'lg',
      windowClass: 'full-modal m-translator',
    };
    this.modalService.open(this.content, modalOptions);
  }
}



// WEBPACK FOOTER //
// ./ts/app/shared/mobile-translator-tool/mobile-translator-tool.component.ts